module.exports = __webpack_public_path__ + "sansg/img/tz.2565120b.png";